// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getNotifyStyle } from "@sc/App/Components/Notify";
import { recentQuotesStyles } from "@sc/Overrides/Widgets/Common/RecentQuotes";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

recentQuotesStyles.viewAllLink = {
    ...createLinkIconStyles(ArrowRight, {
        css: css`
            margin-bottom: 16px;
        `,
        icon: {
            position: "right",
        },
    }),
};

recentQuotesStyles.noQuotesText = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin: 0;
        `,
    }),
};
recentQuotesStyles.noQuotesGridItem = {
    css: css`
        padding: 0;
    `,
};
recentQuotesStyles.dataTable = {
    css: css`
        td[class^="DataTableCellBase"] {
            & > ${TypographyStyle}:empty:after {
                content: "- -";
            }
        }
    `,
};
